"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseInputStyles = {
    margin: '0 30px 0 0',
    maxWidth: '100%',
    width: '190px'
};
exports.styles = {
    controlWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        root: baseInputStyles
    },
    textFieldLong: {
        root: {
            ...baseInputStyles,
            width: '290px'
        }
    },
    dropdown: {
        root: baseInputStyles
    }
};
